"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var Student_1 = require("../../../../classes/Student");
var Order_1 = require("../../../../classes/Order");
var saveToDisk_1 = require("../../../../common/helpers/saveToDisk");
var time_1 = require("../../../../common/helpers/time");
var AdminStudentViewController = /** @class */ (function () {
    function AdminStudentViewController($state, $stateParams, UsersModel, FlashService, $window, AdminTasksService, CreateOrderService, balance, $q, APPURL, PoliciesModel, OnlineDriversEd, $sce, CustomerSourceModel, $rootScope, PoliciesStoreService, VueStoreFactory) {
        var _this = this;
        this.$q = $q;
        this.VueStoreFactory = VueStoreFactory;
        this.$sce = $sce;
        this.APPURL = APPURL;
        AdminTasksService.clearTasks();
        this.CreateOrderService = CreateOrderService;
        this.AdminTasksService = AdminTasksService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.$window = $window;
        this.student = null;
        this.hasNextSession = false;
        this.initialLoad = true;
        this.busy = false;
        this.pickuplocations = [];
        this.using_drive_deadline = false;
        this.customerSources = [];
        this.marketingOptions = [];
        // get the marketing options
        CustomerSourceModel.getCustomerSources().then(function (response) {
            _this.marketingOptions = response.customer_sources;
        });
        this.studentNotes = VueStoreFactory.state.studentNotes;
        this.notesPage = 1;
        this.loadStudentNotes(1);
        this.updateDriveDeadline = this.updateDriveDeadline.bind(this);
        $rootScope.$on("STUDENT_SETUP_COMPLETE", function (event, data) {
            if (data && data.home_address) {
                _this.home_address = data.home_address;
            }
        });
        this.preferred_pronoun_enabled = false;
        PoliciesModel.getByID("studentmetadata").then(function (response) {
            var policyMeta = {};
            response.policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = meta.meta_value;
            });
            if (policyMeta.preferred_pronoun) {
                _this.preferred_pronoun_enabled = true;
            }
        });
        PoliciesModel.getByID("drives")
            .then(function (response) {
            _this.using_drive_deadline =
                response.policy.policymeta.find(function (meta) { return meta.meta_key === "enable_drive_deadline"; }).meta_value === "Y";
        })
            .catch(function (Error) {
            _this.using_drive_deadline = false;
        });
        this.OnlineDriversEd = OnlineDriversEd;
        this.onlineDriversEdConfig = {
            available: false,
            enabled: false,
        };
        this.messengerUsers = [];
        UsersModel.getStudentUsageDetails($stateParams.userId).then(function (response) {
            _this.usageDetails = response.data;
        });
        UsersModel.getStudentCustomerSources($stateParams.userId).then(function (response) {
            _this.customerSources = response.customer_sources;
        });
        UsersModel.getStudentCourseDetails($stateParams.userId).then(function (response) {
            _this.courses = response.data;
        });
        this.requirements = [];
        UsersModel.requirements($stateParams.userId).then(function (response) {
            _this.requirements = response.requirements;
        });
        var getStudent = UsersModel.getStudentByID($stateParams.userId);
        var getPickupLocations = UsersModel.getPickupLocations($stateParams.userId);
        var getOnlineDriversEdDetails = OnlineDriversEd.getFeatureDetails();
        $q.all([getStudent, getPickupLocations, getOnlineDriversEdDetails]).then(function (responses) {
            if (responses[0].usermeta.permit) {
                responses[0].usermeta.permit.issuedate = (0, time_1.dateStringToDate)(responses[0].usermeta.permit.issuedate);
                responses[0].usermeta.permit.expirationdate = (0, time_1.dateStringToDate)(responses[0].usermeta.permit.expirationdate);
            }
            if (responses[0].usermeta.home_address) {
                _this.home_address = responses[0].usermeta.home_address;
            }
            // Address is already an object from backend
            responses[0].amount_owed = balance;
            responses[0].zoneparts = (0, uniqBy_1.default)(responses[0].zoneparts, "zone_id");
            _this.pickuplocations = responses[1].pickuplocations;
            if (responses[0].usermeta.hasOwnProperty("drive_deadline")) {
                responses[0].usermeta.drive_deadline = (0, time_1.dateStringToDate)(responses[0].usermeta.drive_deadline);
            }
            else {
                responses[0].usermeta.drive_deadline = null;
            }
            _this.student = responses[0];
            _this.onlineDriversEdConfig.available = responses[2].available;
            _this.onlineDriversEdConfig.enabled = responses[2].enabled;
            _this.messengerUsers.push({
                id: _this.student.id,
                name: _this.student.fullname,
            });
            // Set an empty new order with this student attached to it if the admin visits the "create order" page
            var $student = new Student_1.Student(_this.student);
            var order = new Order_1.Order();
            order.setStudent($student);
            _this.CreateOrderService.cashier().setOrder(order);
            _this.student.pickuplocations = _this.pickuplocations;
            _this.getNextSession();
        });
    }
    AdminStudentViewController.prototype.addCustomerSource = function (customerSource) {
        var _this = this;
        if (!customerSource || !this.student) {
            return;
        }
        this.UsersModel.addStudentCustomerSources(this.student.id, customerSource.id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.customerSources = response.customer_sources;
        });
    };
    AdminStudentViewController.prototype.toggleOnlineDriversEdRequired = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.OnlineDriversEd.updateOnlineDriversEdFields({
            id: this.student.id,
            ode_required: this.student.ode_required,
            ode_completed: this.student.ode_completed,
        })
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: Error.message,
            });
        });
    };
    AdminStudentViewController.prototype.printProfile = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.UsersModel.printStudentAccount(this.student.id)
            .then(function (response) {
            _this.busy = false;
            var filename = response.file.split("/")[response.file.split("/").length - 1];
            (0, saveToDisk_1.saveToDisk)(response.file, filename);
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    AdminStudentViewController.prototype.archiveUser = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.UsersModel.archiveStudent(this.student.id).then(function (response) {
            var confirm = _this.$window.confirm("Are you sure you want to archive this student?");
            if (!confirm) {
                return;
            }
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.student) {
                _this.student.status = "Archived";
            }
        });
    };
    AdminStudentViewController.prototype.activateUser = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.UsersModel.activateStudent(this.student.id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.student) {
                _this.student.status = "Active";
            }
        });
    };
    AdminStudentViewController.prototype.deactivateUser = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.UsersModel.deactivateStudent(this.student.id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            if (_this.student) {
                _this.student.status = "Inactive";
            }
        });
    };
    AdminStudentViewController.prototype.updateDriveDeadline = function (newDate) {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.student.usermeta.drive_deadline = (0, time_1.toYMD)(newDate);
        this.UsersModel.updateDriveDeadline(this.student.id, {
            drive_deadline: (0, time_1.toYMD)(newDate),
        })
            .then(function (response) {
            if (_this.student) {
                _this.student.deadline = response.student.deadline;
                _this.student.status = response.student.status;
            }
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
        })
            .catch(function (Error) {
            console.error(Error);
        });
    };
    AdminStudentViewController.prototype.getNextSession = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        this.UsersModel.getNextStudentEntity({ id: this.student.id }).then(function (response) {
            if ((0, isEmpty_1.default)(response.entity)) {
                _this.nextSession = {};
                _this.hasNextSession = false;
            }
            else {
                _this.nextSession = {
                    nextDrive: response.entity,
                    nextDriveDate: new Date(response.entity.date + " " + response.entity.time),
                    untilDrive: (0, time_1.formatDateTime)(response.entity.date + " " + response.entity.time, "h:mm A"),
                };
                _this.hasNextSession = true;
            }
            _this.initialLoad = false;
        });
    };
    AdminStudentViewController.prototype.sendWelcomeEmail = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        var confirm = this.$window.confirm("Are you sure you want to send the welcome email? This will also reset this users password.");
        if (confirm === false) {
            return false;
        }
        this.busy = true;
        this.UsersModel.sendWelcomeEmail(this.student.id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.busy = false;
        });
    };
    // notes
    AdminStudentViewController.prototype.formatNoteContent = function (note) {
        return this.$sce.trustAsHtml(note);
    };
    AdminStudentViewController.prototype.loadStudentNotes = function (page) {
        var _this = this;
        this.submitting = true;
        return this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/GET_STUDENT_NOTES", {
            studentId: Number(this.$stateParams.userId),
            page: page,
        }))
            .then(function () {
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentViewController.prototype.deleteNote = function (note) {
        var _this = this;
        this.submitting = true;
        this.$q
            .when(this.VueStoreFactory.dispatch("studentNotes/REMOVE_STUDENT_NOTE", {
            studentId: Number(this.$stateParams.userId),
            noteId: note.id,
        }))
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.notesPage = _this.studentNotes.currentPage;
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminStudentViewController.prototype.getRole = function (role) {
        if (role === 1) {
            return "Students";
        }
        if (role === 3) {
            return "Instructors";
        }
        if (role === 4) {
            return "Owners";
        }
        if (role === 5) {
            return "Administrators";
        }
        if (role === 9) {
            return "Staff";
        }
        return "Owner";
    };
    AdminStudentViewController.prototype.studentNotesPageChanged = function () {
        this.loadStudentNotes(this.notesPage);
    };
    AdminStudentViewController.prototype.deleteStudentAccount = function () {
        var _this = this;
        if (!this.student) {
            return;
        }
        var confirm = this.$window.confirm("Are you sure you want to delete this student account?");
        if (!confirm) {
            return;
        }
        this.busy = true;
        this.UsersModel.deleteStudent(this.student)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.busy = false;
            _this.$state.go("drivecoach.admin.students.index");
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    return AdminStudentViewController;
}());
AdminStudentViewController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "$window",
    "AdminTasksService",
    "CreateOrderService",
    "balance",
    "$q",
    "APPURL",
    "PoliciesModel",
    "OnlineDriversEd",
    "$sce",
    "CustomerSourceModel",
    "$rootScope",
    "PoliciesStoreService",
    "VueStoreFactory",
];
exports.default = AdminStudentViewController;
